import { React, useState, useEffect } from 'react'
import logo from '../images/LOGO_SHEN_v2-3.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faXmark, faAngleDown } from '@fortawesome/free-solid-svg-icons'
import frFlag from '../images/FRAN.png'
import enFlag from '../images/ENGL.png'
import { useLang } from "./Provider/LanguageProvider";

function MobileNavbar() {
  const [showNav, setShowNavbar] = useState(false)
  const [currentPage, SetCurrentPage] = useState(window.location.pathname);
  const { language,setLanguage } = useLang();

  const handleMouseClickLang = () => {
    const langTag = document.getElementById('lang');
    const currentDisplay = window.getComputedStyle(langTag).display;
    const arrow = document.getElementById('down-arrow')

    if (currentDisplay === 'none') {
      langTag.style.display = 'block';
      arrow.style.transform = "rotate(180deg)";
      arrow.style.paddingRight = "0.4rem";
    } else {
      langTag.style.display = 'none';
      arrow.style.transform = "rotate(0)";
    }
  }

  const switchLang = () => {
    if (language === "fr") {
      setLanguage("en")
    } else {
      setLanguage("fr")
    }
  }

  const handleShowNavbar = () => {
    if (showNav) {
      setShowNavbar(false)
    } else {
      setShowNavbar(true)
    }
  }

  useEffect(() => {
    SetCurrentPage(window.location.pathname);
  }, [])


  return (
    <div id='mobile-nav'>
      <div className='container'>
        <a href='/' className='logo-cont'>
          <img src={logo} alt="Shenimed logo" />
        </a>
        <div className='right-cont'>
          <div className='language-menu' onClick={handleMouseClickLang}>
            {language === "fr" ? <img src={frFlag} alt='flag' /> : <img src={enFlag} alt='flag' />}
            <span className='down-arrow' id='down-arrow'><FontAwesomeIcon icon={faAngleDown} /></span>
            <div className='submenu' id='lang' onClick={switchLang}>
              {language !== "fr" ? <img src={frFlag} alt='flag' /> : <img src={enFlag} alt='flag' />}
            </div>
          </div>
          <div className={`menu  ${showNav && 'active'}`}>
            {showNav ? <button onClick={handleShowNavbar}><FontAwesomeIcon icon={faXmark} /></button> : <button onClick={handleShowNavbar}><FontAwesomeIcon icon={faBars} /></button>}
            <ul className='menu-list'>
              <li className={currentPage === '/' ? 'current-page item' : 'item'}>
                <a href='/' >{language === 'fr' ? 'ACCUEIL' : 'HOME'}</a>
              </li>
              <li className={currentPage === '/notrentreprise' ? 'current-page item' : 'item'}>
                <a href='/notrentreprise' >{language === 'fr' ? 'NOTRE ENTREPRISE' : 'OUR COMPANY'}</a>
              </li>
              <li className={currentPage === '/nosmarques' ? 'current-page item' : 'item'}>
                <a href='/nosmarques'>{language === 'fr' ? 'NOS MARQUES' : 'OUR BRANDS'}</a>
              </li>
              <li className={currentPage === '/nosengagements' ? 'current-page item' : 'item'}>
                <a href='/nosengagements'>{language === 'fr' ? 'NOS ENGAGEMENTS' : 'COMMITMENTS'}</a>
              </li>
              <li className={currentPage === '/nosagences' ? 'current-page item  last-item' : 'item  last-item'}>
                <a href='/nosagences'>{language === 'fr' ? 'NOS AGENCES' : 'AGENCIES'}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className='line-nav'>
      </div>
    </div>
  )
}

export default MobileNavbar